/**
 * PLACEHOLDER Terms of Service — generic boilerplate drafted in-house, branded
 * for VNETWORK JOINT STOCK COMPANY. This is NOT legal advice and is NOT the company's official
 * terms. Replace `TERMS_SECTIONS` with the counsel-reviewed text before launch.
 */
import { brand } from '@/config/brand';
export const COMPANY_NAME = brand.legalName;
export const TERMS_EFFECTIVE_DATE = '29 May 2026'; // e.g. "1 January 2026" — fill in.

export interface TermsSection {
  heading: string;
  paragraphs: string[];
}

export const TERMS_SECTIONS: TermsSection[] = [
  {
    heading: '1. Acceptance of Terms',
    paragraphs: [
      `These Terms of Service ("Terms") govern your access to and use of the websites, products, and services made available by ${COMPANY_NAME} ("the Company", "we", "us"). By creating an account, accessing, or using the services, you agree to be bound by these Terms.`,
      'If you are entering into these Terms on behalf of an organization, you represent that you have authority to bind that organization, and "you" refers to that organization.',
    ],
  },
  {
    heading: '2. Definitions',
    paragraphs: [
      '"Services" means the websites, applications, APIs, and related offerings provided by the Company. "Account" means the registered profile through which you access the Services. "Content" means any data, text, or materials you submit to or through the Services.',
    ],
  },
  {
    heading: '3. Eligibility and Accounts',
    paragraphs: [
      'You must provide accurate, current, and complete information when registering and keep it up to date. You are responsible for safeguarding your account credentials and for all activity under your account.',
      'You must notify the Company promptly of any unauthorized use of your account or any other breach of security.',
    ],
  },
  {
    heading: '4. Acceptable Use',
    paragraphs: [
      'You agree not to misuse the Services. This includes, without limitation, not attempting to gain unauthorized access, not interfering with the integrity or performance of the Services, and not using the Services to distribute unlawful, infringing, or harmful material.',
      'The Company may suspend or limit access to protect the Services or other users.',
    ],
  },
  {
    heading: '5. Fees and Payment',
    paragraphs: [
      'Certain Services may be offered for a fee. Fees, billing cycles, and applicable taxes will be described at the point of purchase. Unless stated otherwise, fees are non-refundable.',
      'The Company may change pricing with reasonable prior notice. Continued use after a price change constitutes acceptance of the updated fees.',
    ],
  },
  {
    heading: '6. Customer Content',
    paragraphs: [
      'You retain all rights in your Content. You grant the Company a limited license to host, process, and transmit your Content solely as necessary to provide the Services.',
      'You are solely responsible for your Content and for ensuring you have the rights necessary to submit it.',
    ],
  },
  {
    heading: '7. Intellectual Property',
    paragraphs: [
      `The Services, including all software, design, and trademarks, are owned by ${COMPANY_NAME} or its licensors and are protected by intellectual property laws. No rights are granted except as expressly set out in these Terms.`,
    ],
  },
  {
    heading: '8. Privacy',
    paragraphs: [
      'Your use of the Services is subject to the Company privacy policy, which describes how personal data is collected and processed. By using the Services, you consent to such processing.',
    ],
  },
  {
    heading: '9. Third-Party Services',
    paragraphs: [
      'The Services may integrate with or link to third-party services. The Company is not responsible for third-party services, and your use of them is governed by their own terms.',
    ],
  },
  {
    heading: '10. Disclaimers',
    paragraphs: [
      'The Services are provided "as is" and "as available" without warranties of any kind, whether express or implied, to the maximum extent permitted by law, including warranties of merchantability, fitness for a particular purpose, and non-infringement.',
    ],
  },
  {
    heading: '11. Limitation of Liability',
    paragraphs: [
      `To the maximum extent permitted by law, ${COMPANY_NAME} will not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, arising out of or related to your use of the Services.`,
    ],
  },
  {
    heading: '12. Termination',
    paragraphs: [
      'You may stop using the Services at any time. The Company may suspend or terminate your access if you breach these Terms or if required to do so by law. Provisions that by their nature should survive termination will survive.',
    ],
  },
  {
    heading: '13. Changes to These Terms',
    paragraphs: [
      'The Company may update these Terms from time to time. Material changes will be communicated through the Services or by other reasonable means. Your continued use after changes take effect constitutes acceptance.',
    ],
  },
  {
    heading: '14. Governing Law',
    paragraphs: [
      'These Terms are governed by the laws of the Socialist Republic of Vietnam, without regard to conflict-of-laws principles. Disputes will be subject to the competent courts having jurisdiction.',
    ],
  },
  {
    heading: '15. Contact',
    paragraphs: [
      `Questions about these Terms may be directed to ${COMPANY_NAME} by email at ${brand.emails.legal} or by hotline at ${brand.hotline}.`,
    ],
  },
];
